import { Box, Flex, SvgIcon } from '@volue/wave-react';
import React from 'react';

import type { MvShortCircuitSummaryEvaluatedResults } from '@/features/execute-calculation-set/overmind/calculation/derived-state/shortCircuitSummary/mediumVoltage/MvShortCircuitSummaryEvaluatedResults';
import { getShortCircuitDetailsGridElementsRequiringAttention } from '@/features/execute-calculation-set/overmind/calculation/evaluation/shortCircuit/attentionRequired';
import { useAppState } from '@/overmind';

import { CurrentResults } from './CurrentResults';

export type MvShortCircuitummaryCalculationResultsProps = {
  shortCircuitSummary: MvShortCircuitSummaryEvaluatedResults;
};

export function MvShortCircuitSummaryCalculationResults(
  props: MvShortCircuitummaryCalculationResultsProps
) {
  const shortCircuitSummary = props.shortCircuitSummary;
  const evaluatedGridElements =
    useAppState().calculation.gridElementsDetailsByCalculationType;
  const attentionStatuses =
    useAppState().calculation.gridElementsAttentionStatuses;
  const isEvaluated =
    evaluatedGridElements.type === 'EVALUATED' &&
    attentionStatuses.type === 'AVAILABLE';

  return (
    <Box>
      <Box
        css={{
          color: '$colorAccent70',
          fontWeight: 'bold',
          fontSize: 'larger'
        }}
      >
        <Flex main={'space-between'}>
          <Box>{'Short Circuit'}</Box>
          {isEvaluated && (
            <Box
              data-testid="loadflow-attention-needed-counter"
              css={{ color: '$colorOrange70' }}
            >
              <SvgIcon iconName="warning" className="mRs" />
              {
                getShortCircuitDetailsGridElementsRequiringAttention(
                  evaluatedGridElements.gridElementsDetails,
                  attentionStatuses.byCalculationType.shortCircuit
                ).length
              }
            </Box>
          )}
        </Flex>
      </Box>

      <CurrentResults
        label="MV Busbar currents"
        summary={shortCircuitSummary.mvBusbars}
      />
      <CurrentResults
        label="Energy consumers currents"
        summary={shortCircuitSummary.energyConsumers}
      />
    </Box>
  );
}
